import { i18n } from "@lingui/core";

import { loadCatalog } from "./catalogs";
import type { Locale } from "./locales";

// Загружает каталоги языка и переключает интерфейс без перезагрузки страницы.
// Сохранение выбора в профиль — забота фичи, которая меняет язык.
export const activateLocale = async (locale: Locale): Promise<void> => {
  const messages = await loadCatalog(locale);
  i18n.loadAndActivate({ locale, messages });
  document.documentElement.lang = locale;
};
